import type { SVGProps } from "react";
import * as React from "react";
const SvgMicrosoftPowerpoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FFAA0D"
      d="M13.5 13 12 2h-.112C6.434 2.016 2.016 6.434 2 11.888V12l11.5 1Z"
    />
    <path
      fill="#FFD046"
      d="M12.112 2H12v10l5 2 5-2v-.112C21.984 6.434 17.566 2.016 12.112 2Z"
    />
    <path
      fill="#E38122"
      d="M22 12v.11c-.016 5.456-4.434 9.874-9.89 9.89h-.22c-5.456-.016-9.874-4.434-9.89-9.89V12h20Z"
    />
    <path
      fill="#713912"
      d="M2.833 7h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H2.833A.833.833 0 0 1 2 16.167V7.833c0-.46.373-.833.833-.833Z"
    />
    <path
      fill="#fff"
      d="M7.071 9.006c.511-.04 1.017.13 1.429.48.343.353.526.866.497 1.394.006.366-.08.727-.245 1.04-.168.309-.41.554-.696.708a2.107 2.107 0 0 1-1.047.253h-.993V15H5V9.006h2.071Zm-1.056 2.959h.875c.277.023.552-.07.773-.265.183-.201.279-.485.262-.776 0-.66-.334-.99-1.002-.99h-.908v2.031Z"
    />
  </svg>
);
export default SvgMicrosoftPowerpoint;
